import { getServerEnv } from '#/shared/lib/server-env'

const env = getServerEnv()

export abstract class AuthConstants {
	public static readonly secret = env.NEXTAUTH_SECRET

	public static readonly redirect_uri_yandex = `https://oauth.yandex.ru/authorize?&redirect_uri=${env.NEXT_REDIRECT_URI_YANDEX}`

	public static readonly django_app_client_id_yandex = env.NEXT_DJANGO_YANDEX_APP_CLIENT_ID

	public static readonly django_app_client_secret_yandex = env.NEXT_DJANGO_YANDEX_APP_CLIENT_SECRET

	public static readonly client_id_yandex = env.NEXT_CLIENT_ID_YANDEX

	public static readonly client_secret_yandex = env.NEXT_CLIENT_SECRET_YANDEX

	public static readonly sessionTime =
		Number(env.NEXT_SESSION_TIME ?? env.NEXT_PUBLIC_SESSION_TIME) * 1000

	private static readonly expiresTime = this.sessionTime

	public static readonly getExpiresDate = () => Date.now() + this.expiresTime
}

// TODO: перекинуть slug-коды на бэк
export const ERROR_MAPPING: Record<string, string> = {
	'Неверный email': 'email_not_correct',
	'Неверный пароль': 'password_not_correct',
	'Пользователь пока не подтвердил свой email': 'email_not_approved',
}

export const ERROR_YANDEX_MAPPING: Record<string, string> = {
	"Your credentials aren't allowed": 'yandex_credentials_not_allowed',
	'Invalid client_id parameter value.': 'yandex_client_id_not_correct',
}

export const ERRROR_YANDEX_TRANSLATE_MAPPING: Record<string, string> = {
	yandex_credentials_not_allowed: 'Неверные учетные данные',
	yandex_client_id_not_correct: 'Ошибка сервера (скоро поправим)',
}
